import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Modal } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import plus from "../../assets/Images/plus.svg";
import { activateSubStore, deactivateSubStore, deleteSubStore, getSubStoreDetails, getSubstores } from "../../API  Functions/ProfileFunctions";
import AllSubStoreTable from "./Tables/allSubStoreTable";
import CreateSubStoreModal from "../../modals/CreateSubStoreModal";
import CreateSubStore from "./createSubStore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import LoadingSpinner from "../../components/Loading";


const AllSubStore = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const masterStore = useSelector((state) => state.login.masterStore);
    const [loading, setLoading] = useState(true);
    const [mainLoading, setMainLoading] = useState(false);


    const [showComponent, setShowComponent] = useState(false);
    const [subStoreVersion, setSubStoreVersion] = useState(0);


    // Full list of substores from API
    const [allSubStores, setAllSubStores] = useState([]);

    // Pagination state
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const [paginatedSubStores, setPaginatedSubStores] = useState([]);

    const [isEdit, setIsEdit] = useState(false);
    const [editSubStoreData, setEditSubStoreData] = useState(null);

    const [branchLimit, setBranchLimit] = useState(0); // total allowed
    const [activeBranchesCount, setActiveBranchesCount] = useState(0); // active ones
    const [remainingBranches, setRemainingBranches] = useState(0); // allowed - active


    useEffect(() => {
        if (!showComponent) {
            setIsEdit(false);
            setEditSubStoreData(null);
            getSubStoresData()
        }
    }, [showComponent]);


    const handleEdit = async (sub_store_id) => {
        try {
            setLoading(true); // optional: show loading state
            const data = await getSubStoreDetails(sub_store_id, i18n.language === "ar" ? "ar_001" : "en_US");
            // console.log("Edit Data:", data);
            if (data?.result?.status_code == 200) {
                setIsEdit(true);
                setEditSubStoreData(data?.result?.response);
                setShowComponent(true);
            }
        } catch (error) {
            toast.error(t("Failed to load Sub-Store details for editing."));
        } finally {
            setLoading(false);
        }
    };

    // Fetch and store all substores once
    const getSubStoresData = useCallback(() => {
        if (!masterStore?.store_id) return;

        setLoading(true);
        getSubstores(masterStore.store_id)
            .then((res) => {
                const fullData = res?.response.filter(item => item.is_warehouse === false) || [];

                console.log("res----->", res);


                // Extract total allowed branches
                const totalAllowed = res?.no_of_branch || 0;

                // Count active branches
                const activeCount = fullData.filter(item => item.active === true).length;

                // Compute remaining
                const remaining = totalAllowed - activeCount;

                // console.log("totalAllowed----->", totalAllowed);
                // console.log("activeCount----->", activeCount);
                // console.log("remaining----->", remaining);




                setBranchLimit(totalAllowed);
                setActiveBranchesCount(activeCount);
                setRemainingBranches(remaining);


                setAllSubStores(fullData);
                setPageIndex(1);
                paginateData(fullData, 1, pageSize);
            })
            .finally(() => setLoading(false));
    }, [masterStore?.store_id, pageSize]);

    // Slice data for frontend pagination
    const paginateData = (data, currentPage, size) => {
        const start = (currentPage - 1) * size;
        const end = start + size;
        setPaginatedSubStores(data.slice(start, end));
    };

    // Handle page or size change
    const handlePageChange = (newPage) => {
        setPageIndex(newPage);
        paginateData(allSubStores, newPage, pageSize);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageIndex(1);
        paginateData(allSubStores, 1, newSize);
    };

    useEffect(() => {
        if (masterStore) {
            getSubStoresData();
        }
    }, [masterStore, getSubStoresData]);

    const closeCreateSubStore = () => {
        setShowComponent(false);
        setIsEdit(false);
        setEditSubStoreData(null);
        getSubStoresData();
    };



    const handleToggleStatus = async (subStoreId, currentStatus) => {
        const newStatus = !currentStatus;
        setMainLoading(true);

        try {
            let response;

            if (newStatus) {
                response = await activateSubStore(subStoreId);

                const result = response?.data?.result?.[0];

                if (result?.status_code === 400) {
                    let errorMessage = t("Failed to activate branch");

                    const backendMessage = result?.status || "";

                    // Pattern-based matching
                    if (/maximum branch limit/i.test(backendMessage)) {
                        errorMessage = t("You cannot active a branch. The maximum branch limit has been reached.");
                    } else {
                        // If translation key exists for exact message, use it
                        errorMessage = t(backendMessage) || errorMessage;
                    }

                    toast.error(errorMessage);
                    return;
                }

                // if (result?.status_code === 400) {
                //     toast.error(t(result.status) || t("Failed to activate branch"));
                //     return;
                // }

                toast.success(t("Branch activated successfully"));
            } else {
                response = await deactivateSubStore(subStoreId);
                toast.success(t("Branch deactivated successfully"));
            }

            getSubStoresData();
            setSubStoreVersion(prev => prev + 1);

        } catch (error) {
            console.error(error);
            toast.error(t("Error toggling status"));
        } finally {
            setMainLoading(false);
        }
    };




    const handleDelete = (subStoreId) => {
        Modal.confirm({
            title: t("Are you sure you want to delete this branch?"),
            icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
            // content: t("This action cannot be undone."),
            okText: t("Yes"),
            cancelText: t("No"),
            okButtonProps: {
                className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
            },
            onOk: async () => {
                try {
                    await deleteSubStore(subStoreId);
                    toast.success(t("Branch deleted successfully"));
                    getSubStoresData(); 
                } catch (error) {
                    toast.error(t("Error deleting sub-store"));
                }
            },
        });
    };


    return (
        <>
            {mainLoading && <LoadingSpinner />}

            <div className="w-full flex flex-col pb-2 overflow-y-auto bg-[#F6F7F9]">
                <Navbar heading="Branches" subStoreVersion={subStoreVersion} />
                <div className="flex-grow overflow-y-auto custom-scrollbar">
                    <div className="font-extrabold mb-3 mx-5">
                        <Breadcrumb
                            separator={<DoubleRightOutlined />}
                            items={
                                showComponent
                                    ? [
                                        {
                                            title: (
                                                <span
                                                    className="cursor-pointer hover:bg-gray-200 hover:text-black"
                                                    onClick={() => setShowComponent(false)}
                                                >
                                                    {t("All Branches")}
                                                </span>
                                            ),
                                            key: "All-Branches",
                                        },
                                        {
                                            title: isEdit ? t("Update Branch Details") : t("Create Branch"),
                                            key: isEdit ? "update-branch" : "create-branch",
                                            // title: t("Create Branch"),
                                            // key: "create-branch",
                                        },
                                    ]
                                    : []
                            }
                            className="relative mt-3 font-semibold"
                        />
                    </div>

                    {/* Top right buttons */}
                    <div className="flex justify-between items-center mx-5 mb-2">

                        {/* Remaining branch info */}
                        {!showComponent && (
                            <div className="text-gray-600 font-medium">
                                {branchLimit > 0 && (
                                    remainingBranches > 0 ? (
                                        <p>
                                            {t("You can create")}{" "}
                                            <span className="font-bold text-primaryBlue">
                                                {remainingBranches}
                                            </span>{" "}
                                            {t("more branch")}
                                        </p>
                                    ) : (
                                        <p className="text-red font-normal">
                                            {t("Branch limit reached. You cannot create more branches.")}
                                        </p>
                                    )
                                )}
                            </div>
                        )}

                        {!showComponent && (
                            <button
                                // onClick={handleCreateSubStore}
                                disabled={remainingBranches <= 0}
                                onClick={() => setShowComponent(true)}
                                className={`font-semibold w-48 h-10 border rounded-lg flex justify-center items-center gap-2 ${remainingBranches <= 0
                                    ? "bg-gray-400 cursor-not-allowed text-white"
                                    : "bg-primaryBlue hover:bg-primaryBlue text-white"
                                    }`}
                            // className="font-semibold w-48 h-10 border rounded-lg bg-primaryBlue text-white text-base flex justify-center items-center gap-2"
                            >
                                <img src={plus} alt="plus" />
                                <p>{t("Create Branch")}</p>
                            </button>
                        )}
                    </div>

                    {!showComponent ? (
                        <div className="mt-3 mx-5">
                            <AllSubStoreTable
                                loading={loading}
                                additionalData={paginatedSubStores}
                                totalCount={allSubStores.length}
                                pageIndex={pageIndex}
                                pageSize={pageSize}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                                onToggleStatus={handleToggleStatus}
                                handleDelete={handleDelete}
                                handleEdit={handleEdit}
                            />
                        </div>
                    ) : (
                        <CreateSubStore
                            isOpen={showComponent}
                            isEdit={isEdit}
                            editData={editSubStoreData}
                            onClose={closeCreateSubStore}
                        />

                    )}
                </div>
            </div>
        </>
    );
};

export default AllSubStore;
